export default __webpack_public_path__ + "static/media/citi.47960360.jpg";